import {
  RightNavContentType,
  RightNavMode,
  ChildFilter,
  EventBusEvents,
  RecentActivityTypes,
  SaleTypes,
  SaleTypeNames,
  CoreUserStatus,
  ActivityFeedCategory,
  SpecialActionTypeIds
} from "@/lib/utilities/enums";
import store from "@/store";
import EventBus from "@/lib/utilities/eventBus";
import linkifyHtml from "linkifyjs/html";

export var HelperFunctions = {
  xml2json(xml, tab) {
    var X = {
      toObj: function(xml) {
        var o = {};
        if (xml.nodeType == 1) {
          // element node ..
          if (xml.attributes.length)
            // element with attributes  ..
            for (var i = 0; i < xml.attributes.length; i++)
              o["@" + xml.attributes[i].nodeName] = (
                xml.attributes[i].nodeValue || ""
              ).toString();
          if (xml.firstChild) {
            // element has child nodes ..
            var textChild = 0,
              cdataChild = 0,
              hasElementChild = false;
            for (var n = xml.firstChild; n; n = n.nextSibling) {
              if (n.nodeType == 1) hasElementChild = true;
              else if (n.nodeType == 3 && n.nodeValue.match(/[^ \f\n\r\t\v]/))
                textChild++;
              // non-whitespace text
              else if (n.nodeType == 4) cdataChild++; // cdata section node
            }
            if (hasElementChild) {
              if (textChild < 2 && cdataChild < 2) {
                // structured element with evtl. a single text or/and cdata node ..
                X.removeWhite(xml);
                for (var n = xml.firstChild; n; n = n.nextSibling) {
                  if (n.nodeType == 3)
                    // text node
                    o["#text"] = X.escape(n.nodeValue);
                  else if (n.nodeType == 4)
                    // cdata node
                    o["#cdata"] = X.escape(n.nodeValue);
                  else if (o[n.nodeName]) {
                    // multiple occurence of element ..
                    if (o[n.nodeName] instanceof Array)
                      o[n.nodeName][o[n.nodeName].length] = X.toObj(n);
                    else o[n.nodeName] = [o[n.nodeName], X.toObj(n)];
                  } // first occurence of element..
                  else o[n.nodeName] = X.toObj(n);
                }
              } else {
                // mixed content
                if (!xml.attributes.length) o = X.escape(X.innerXml(xml));
                else o["#text"] = X.escape(X.innerXml(xml));
              }
            } else if (textChild) {
              // pure text
              if (!xml.attributes.length) o = X.escape(X.innerXml(xml));
              else o["#text"] = X.escape(X.innerXml(xml));
            } else if (cdataChild) {
              // cdata
              if (cdataChild > 1) o = X.escape(X.innerXml(xml));
              else {
                for (var n = xml.firstChild; n; n = n.nextSibling)
                  o["cdata"] = X.escape(n.nodeValue);
              }
            }
          }
          if (!xml.attributes.length && !xml.firstChild) o = null;
        } else if (xml.nodeType == 9) {
          // document.node
          o = X.toObj(xml.documentElement);
        } else alert("unhandled node type: " + xml.nodeType);
        return o;
      },
      toJson: function(o, name, ind) {
        var json = name ? '"' + name + '"' : "";
        if (o instanceof Array) {
          for (var i = 0, n = o.length; i < n; i++)
            o[i] = X.toJson(o[i], "", ind + "\t");
          json +=
            (name ? ":[" : "[") +
            (o.length > 1
              ? "\n" + ind + "\t" + o.join(",\n" + ind + "\t") + "\n" + ind
              : o.join("")) +
            "]";
        } else if (o == null) json += (name && ":") + "null";
        else if (typeof o == "object") {
          var arr = [];
          for (var m in o) arr[arr.length] = X.toJson(o[m], m, ind + "\t");
          json +=
            (name ? ":{" : "{") +
            (arr.length > 1
              ? "\n" + ind + "\t" + arr.join(",\n" + ind + "\t") + "\n" + ind
              : arr.join("")) +
            "}";
        } else if (typeof o == "string")
          json += (name && ":") + '"' + o.toString() + '"';
        else json += (name && ":") + o.toString();
        return json;
      },
      innerXml: function(node) {
        var s = "";
        if ("innerHTML" in node) s = node.innerHTML;
        else {
          var asXml = function(n) {
            var s = "";
            if (n.nodeType == 1) {
              s += "<" + n.nodeName;
              for (var i = 0; i < n.attributes.length; i++)
                s +=
                  " " +
                  n.attributes[i].nodeName +
                  '="' +
                  (n.attributes[i].nodeValue || "").toString() +
                  '"';
              if (n.firstChild) {
                s += ">";
                for (var c = n.firstChild; c; c = c.nextSibling) s += asXml(c);
                s += "</" + n.nodeName + ">";
              } else s += "/>";
            } else if (n.nodeType == 3) s += n.nodeValue;
            else if (n.nodeType == 4) s += "<![CDATA[" + n.nodeValue + "]]>";
            return s;
          };
          for (var c = node.firstChild; c; c = c.nextSibling) s += asXml(c);
        }
        return s;
      },
      escape: function(txt) {
        return txt
          .replace(/[\\]/g, "\\\\")
          .replace(/[\"]/g, '\\"')
          .replace(/[\n]/g, "\\n")
          .replace(/[\r]/g, "\\r");
      },
      removeWhite: function(e) {
        e.normalize();
        for (var n = e.firstChild; n; ) {
          if (n.nodeType == 3) {
            // text node
            if (!n.nodeValue.match(/[^ \f\n\r\t\v]/)) {
              // pure whitespace text node
              var nxt = n.nextSibling;
              e.removeChild(n);
              n = nxt;
            } else n = n.nextSibling;
          } else if (n.nodeType == 1) {
            // element node
            X.removeWhite(n);
            n = n.nextSibling;
          } // any other node
          else n = n.nextSibling;
        }
        return e;
      }
    };
    if (xml.nodeType == 9)
      // document node
      xml = xml.documentElement;
    var json = X.toJson(X.toObj(X.removeWhite(xml)), xml.nodeName, "\t");
    return (
      "{\n" +
      tab +
      (tab ? json.replace(/\t/g, tab) : json.replace(/\t|\n/g, "")) +
      "\n}"
    );
  },
  getActionTypesForCategory: function(category) {
    let SpecialActionTypeCategory = [];
    if (category === ActivityFeedCategory.VideoMessaging) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.VideoViewed,
        SpecialActionTypeIds.VideoLinkClicked,
        SpecialActionTypeIds.VideoFormSubmission,
        SpecialActionTypeIds.VideoSent
      ];
    } else if (category === ActivityFeedCategory.O2O) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.OneToOneMail_MailSentO2O,
        SpecialActionTypeIds.OneToOneMail_EMailSentO2O,
        SpecialActionTypeIds.OneToOneMail_EmailClickO2O,
        SpecialActionTypeIds.OneToOneMail_EmailOpenO2O,
        SpecialActionTypeIds.OneToOneMail_pUrlViewedO2O,
        SpecialActionTypeIds.OneToOnePurl_ReadytoReplaceCTAClicked,
        SpecialActionTypeIds.OneToOnePurl_GetYourOfferCTAClicked,
        SpecialActionTypeIds.OneToOnePurl_PrintyourOfferIconClicked,
        SpecialActionTypeIds.OneToOnePurl_DealerWebsiteLinkClickedHeader,
        SpecialActionTypeIds.OneToOnePurl_ReadytoUpgradeCTAClicked,
        SpecialActionTypeIds.OneToOnePurl_pUrlVisitedfromTypein,
        SpecialActionTypeIds.OneToOnePurl_pUrlVisitedfromEmail,
        SpecialActionTypeIds.OneToOnePurl_DealerWebsiteLinkClickedAuthorizedDealerSection,
        SpecialActionTypeIds.OneToOnePurl_PrintYourOfferCTAClicked,
        SpecialActionTypeIds.OneToOnePurl_O2OpUrlViewed,
        SpecialActionTypeIds.OneToOnePurl_O2OpURLLead,
        SpecialActionTypeIds.OneToOnePurl_DealerServiceLinkClickedFooter,
        SpecialActionTypeIds.OneToOnePurl_DealerWebsiteLinkClickedFooter,
        SpecialActionTypeIds.OneToOnePurl_pUrlVisitedfromFacebook
      ];
    } else if (category === ActivityFeedCategory.Email) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.EmailReply_CustomerReplied,
        SpecialActionTypeIds.EmailReply_Completed,
        SpecialActionTypeIds.EmailReply_Closed,
        SpecialActionTypeIds.Email_EmailSent,
        SpecialActionTypeIds.Email_EmailReply,
        SpecialActionTypeIds.Email_CustomerUnsubscribed,
        SpecialActionTypeIds.Email_EmailViewed,
        SpecialActionTypeIds.Email_EmailLinkClicked,
        SpecialActionTypeIds.CustomerHistory_MarkedDoNotEmail,
        SpecialActionTypeIds.CustomerHistory_UnmarkedDoNotEmail,
        SpecialActionTypeIds.Email_IncomingEmail,
        SpecialActionTypeIds.Email_OutgoingEmail,
        SpecialActionTypeIds.Email_EmailOpened,
        SpecialActionTypeIds.Email_BulkEmail,
        SpecialActionTypeIds.Email_AutomatedEmail,
        SpecialActionTypeIds.Email_PandoProcessEmail,
        SpecialActionTypeIds.Email_EmailUnsubscribe,
        SpecialActionTypeIds.Email_EmailBounce,
        SpecialActionTypeIds.Email_EmailDropped,
        SpecialActionTypeIds.Email_AutoResponder,
        SpecialActionTypeIds.CustomerHistory_BadEmail_Invalid,
        SpecialActionTypeIds.CustomerHistory_BadEmail_UserSpecified,
        SpecialActionTypeIds.CustomerHistory_BadEmail_DeliveryBounce,
        SpecialActionTypeIds.PDFEmailBulk
      ];
    } else if (category === ActivityFeedCategory.Phone) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.CompletedCall_LeftMessage,
        SpecialActionTypeIds.CompletedCall_NoAnswer,
        SpecialActionTypeIds.CompletedCall_CallBack,
        SpecialActionTypeIds.CustomerHistory_MarkedDoNotCall,
        SpecialActionTypeIds.CustomerHistory_UnmarkedDoNotCall,
        SpecialActionTypeIds.CompletedCall_Miscellaneous,
        SpecialActionTypeIds.CompletedCall_Interested,
        SpecialActionTypeIds.CompletedCall_NoLongerOwns,
        SpecialActionTypeIds.CompletedCall_ScheduleAppt,
        SpecialActionTypeIds.CompletedCall_NotInterested,
        SpecialActionTypeIds.CompletedCall_HelloWorld,
        SpecialActionTypeIds.CompletedCall_Sold,
        SpecialActionTypeIds.CompletedCall_BadPhoneNumber,
        SpecialActionTypeIds.CompletedCall_DoNotCall,
        SpecialActionTypeIds.CompletedCall_SpokeToClient,
        SpecialActionTypeIds.ScheduleCall_ScheduledCall,
        SpecialActionTypeIds.CompletedCall_Unknown,
        SpecialActionTypeIds.PhoneCallComplete_AppointmentSet,
        SpecialActionTypeIds.PhoneCallComplete_CallBack,
        SpecialActionTypeIds.PhoneCallComplete_DoNotCall,
        SpecialActionTypeIds.PhoneCallComplete_LeftMessage,
        SpecialActionTypeIds.PhoneCallComplete_NoAnswer,
        SpecialActionTypeIds.PhoneCallComplete_NotInterested,
        SpecialActionTypeIds.PhoneCallComplete_Sold,
        SpecialActionTypeIds.PhoneCallComplete_SpokeToClient,
        SpecialActionTypeIds.PhoneCallComplete_BadPhoneNumber,
        SpecialActionTypeIds.PhoneCallComplete_Interested,
        SpecialActionTypeIds.PhoneCallComplete_NoLongerOwns,
        SpecialActionTypeIds.PhoneCallComplete_Miscellaneous,
        SpecialActionTypeIds.ExpirePhoneCall_Expired,
        SpecialActionTypeIds.PhoneCallReschedule_Rescheduled,
        SpecialActionTypeIds.PhoneCallReassign_Reassigned,
        SpecialActionTypeIds.PhoneCallCancel_Canceled,
        SpecialActionTypeIds.CompletedCall_VehiclePaidOff,
        SpecialActionTypeIds.PhoneCallComplete_VehiclePaidOff,
        SpecialActionTypeIds.CompletedCall_LogInboundCall,
        SpecialActionTypeIds.CompletedCall_LogOutboundCall,
        SpecialActionTypeIds.ScheduleCall_SchedulePhoneCall,
        SpecialActionTypeIds.ScheduleCall_SchedulePhoneCallComplete,
        SpecialActionTypeIds.ScheduleCall_ReschedulePhoneCall,
        SpecialActionTypeIds.ScheduleCall_CancelPhoneCall,
        SpecialActionTypeIds.CompletedCall_LogCallInboundAlertMiner,
        SpecialActionTypeIds.CompletedCall_LogCallOutboundAlertMiner,
        SpecialActionTypeIds.CallTracking_RecordedCall
      ];
    } else if (category === ActivityFeedCategory.SMS) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.SMS_IncomingServiceText,
        SpecialActionTypeIds.SMS_IncomingSalesText,
        SpecialActionTypeIds.SMS_OutgoingServiceText,
        SpecialActionTypeIds.SMS_OutgoingSalesText,
        SpecialActionTypeIds.SMS_SalesTextOptOut,
        SpecialActionTypeIds.SMS_SalesTextOptIn,
        SpecialActionTypeIds.SMS_ServiceTextOptOut,
        SpecialActionTypeIds.SMS_ServiceTextOptIn
      ];
    } else if (category === ActivityFeedCategory.Website) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Website_CustomerNowEngaged,
        SpecialActionTypeIds.Website_WebsiteLeadSubmission,
        SpecialActionTypeIds.Website_WebsiteFormSubmission,
        SpecialActionTypeIds.Website_FacebookClicktoDealerWebsite,
        SpecialActionTypeIds.Website_WebsiteVDP,
        SpecialActionTypeIds.Website_WebsiteSRP
      ];
    } else if (category === ActivityFeedCategory.LeadTouchpoint) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.ActiveLeadStages_WaitingOnVehicleCompleted,
        SpecialActionTypeIds.ActiveLeadStages_TradeInCompleted,
        SpecialActionTypeIds.ActiveLeadStages_ShoppingCompleted,
        SpecialActionTypeIds.ActiveLeadStages_ContactAttemptedCompleted,
        SpecialActionTypeIds.ActiveLeadStages_ContactMadeCompleted,
        SpecialActionTypeIds.ActiveLeadStages_WaitingOnVehicleStarted,
        SpecialActionTypeIds.ActiveLeadStages_TradeInStarted,
        SpecialActionTypeIds.ActiveLeadStages_ShoppingStarted,
        SpecialActionTypeIds.ActiveLeadStages_ContactAttemptedStarted,
        SpecialActionTypeIds.ActiveLeadStages_ContactMadeStarted
      ];
    } else if (category === ActivityFeedCategory.SLM) {
      SpecialActionTypeCategory = [
        // Pando Workflow
        SpecialActionTypeIds.Service_CustomerInService,
        SpecialActionTypeIds.PandoWorkflow_SLMCustomer,
        SpecialActionTypeIds.Appointment_ServiceApptScheduled,
        SpecialActionTypeIds.Service_ServiceClosed
      ];
    }
    // else if (category == ActivityFeedCategory.Service) {
    //   SpecialActionTypeCategory = [
    //     SpecialActionTypeIds.Service_CustomerInService,
    //     SpecialActionTypeIds.Service_ServiceClosed
    //   ];
    // }
    else if (category === ActivityFeedCategory.MobileScanning) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.MobileScanning_DriversLicense
      ];
    } else if (category === ActivityFeedCategory.OnlineReview) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.OnlineReview_SalesReview,
        SpecialActionTypeIds.OnlineReview_ServiceReview
      ];
    } else if (category == ActivityFeedCategory.GeoAlert) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.GeoAlert_GeoAlertActive
      ];
    } else if (category == ActivityFeedCategory.AutoAssist) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.AutoAssistant_AutoAssistantHotLead,
        SpecialActionTypeIds.AutoAssistant_ActionRequired,
        SpecialActionTypeIds.AutoAssistant_LeadAtRisk,
        SpecialActionTypeIds.AutoAssistant_Sent_To_AutoAssistant,
        SpecialActionTypeIds.AutoAssistant_Failed_send_to_AutoAssistant,
        SpecialActionTypeIds.AutoAssistant_PhoneNumberDiscovered,
        SpecialActionTypeIds.AutoAssistant_ActionsRequired,
        SpecialActionTypeIds.AutoAssistant_LeadsAtRisk,
        SpecialActionTypeIds.AutoAssistant_HotLead,
        SpecialActionTypeIds.AutoAssistant_LeadToReview,
        SpecialActionTypeIds.AutoAssistant_FurtherAction,
        SpecialActionTypeIds.AutoAssistant_Satisfied,
        SpecialActionTypeIds.AutoAssistant_Disqualified,
        SpecialActionTypeIds.AutoAssistant_NoFurtherAction,
        SpecialActionTypeIds.AutoAssistant_PreparingLead,
        SpecialActionTypeIds.AutoAssistant_Messaging,
        SpecialActionTypeIds.AutoAssistant_Excluded,
        SpecialActionTypeIds.AutoAssistant_Unworkable,
        SpecialActionTypeIds.AutoAssistant_LeadStopped,
        SpecialActionTypeIds.AutoAssistant_ClientStopped,
        SpecialActionTypeIds.AutoAssistant_ConversicaStopped
      ];
    } else if (category === ActivityFeedCategory.OnTheLot) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.DealsheetIntegrations_VinCueAppraisal,
        SpecialActionTypeIds.DealsheetIntegrations_VinCueAppraisalUpdate
      ];
    } else if (category == ActivityFeedCategory.VAuto) {
      // Dealer Integrations
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.DealsheetIntegrations_vAutoAppraisal,
        SpecialActionTypeIds.DealsheetIntegrations_SubmitSmartVincent,
        SpecialActionTypeIds.DealsheetIntegrations_SubmitOasis
      ];
    } else if (category == ActivityFeedCategory.ADFLead) {
      SpecialActionTypeCategory = [SpecialActionTypeIds.ADFLead_CRMLeadForward];
    } else if (category == ActivityFeedCategory.Appointments) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.AppointmentComplete_DidNotShow,
        SpecialActionTypeIds.AppointmentComplete_Showedclosed,
        SpecialActionTypeIds.AppointmentComplete_Showedopen,
        SpecialActionTypeIds.AppointmentComplete_ShowedSold,
        SpecialActionTypeIds.ExpireAppointment_Expired,
        SpecialActionTypeIds.AppointmentReschedule_Rescheduled,
        SpecialActionTypeIds.AppointmentReassign_Reassigned,
        SpecialActionTypeIds.AppointmentCancel_Canceled,
        SpecialActionTypeIds.ScheduleAppt_ScheduleAppointment,
        SpecialActionTypeIds.ScheduleAppt_CancelAppointment,
        SpecialActionTypeIds.ScheduleAppt_SalesApptScheduled,
        SpecialActionTypeIds.Appointment_ConfirmationSent,
        SpecialActionTypeIds.Appointment_ConfirmationReceived,
        SpecialActionTypeIds.Appointment_ConfirmationSent,
        SpecialActionTypeIds.Appointment_ConfirmationReceived
      ];
    } else if (category == ActivityFeedCategory.Appointment_Showroom) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Appointment_Showroom_Scheduled,
        SpecialActionTypeIds.Appointment_Showroom_Rescheduled,
        SpecialActionTypeIds.Appointment_Showroom_Shown,
        SpecialActionTypeIds.Appointment_Showroom_NoShow,
        SpecialActionTypeIds.Appointment_Showroom_Cancelled,
        SpecialActionTypeIds.Appointment_Showroom_Confirmation_Sent,
        SpecialActionTypeIds.Appointment_Showroom_Confirmation_Received
      ];
    } else if (category == ActivityFeedCategory.Appointment_Delivery) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Appointment_Delivery_Scheduled,
        SpecialActionTypeIds.Appointment_Delivery_Rescheduled,
        SpecialActionTypeIds.Appointment_Delivery_Shown,
        SpecialActionTypeIds.Appointment_Delivery_NoShow,
        SpecialActionTypeIds.Appointment_Delivery_Cancelled,
        SpecialActionTypeIds.Appointment_Delivery_Confirmation_Sent,
        SpecialActionTypeIds.Appointment_Delivery_Confirmation_Received
      ];
    } else if (category == ActivityFeedCategory.Appointment_Phone) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Appointment_Phone_Scheduled,
        SpecialActionTypeIds.Appointment_Phone_Rescheduled,
        SpecialActionTypeIds.Appointment_Phone_Shown,
        SpecialActionTypeIds.Appointment_Phone_NoShow,
        SpecialActionTypeIds.Appointment_Phone_Cancelled,
        SpecialActionTypeIds.Appointment_Phone_Confirmation_Sent,
        SpecialActionTypeIds.Appointment_Phone_Confirmation_Received
      ];
    } else if (category == ActivityFeedCategory.Appointment_General) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Appointment_General_Scheduled,
        SpecialActionTypeIds.Appointment_General_Rescheduled,
        SpecialActionTypeIds.Appointment_General_Shown,
        SpecialActionTypeIds.Appointment_General_NoShow,
        SpecialActionTypeIds.Appointment_General_Cancelled,
        SpecialActionTypeIds.Appointment_General_Confirmation_Sent,
        SpecialActionTypeIds.Appointment_General_Confirmation_Received
      ];
    } else if (category == ActivityFeedCategory.Contact) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Contact_AddContact,
        SpecialActionTypeIds.Contact_ContactCreated,
        SpecialActionTypeIds.Contact_ContactUpdate,
        SpecialActionTypeIds.Contact_ContactCompanyUpdate,
        SpecialActionTypeIds.Contact_ContactHouseholdUpdate,
        SpecialActionTypeIds.Contact_ContactMergeStarting,
        SpecialActionTypeIds.Contact_ContactMergeCompleted,
        SpecialActionTypeIds.Contact_ContactMergeFailed,
        SpecialActionTypeIds.Workflow_TasksuppressedduetocontactInformation
      ];
    } else if (category == ActivityFeedCategory.CustomerHistory) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.CustomerHistory_MarkedDonotMail,
        SpecialActionTypeIds.CustomerHistory_UnmarkedDoNotMail
      ];
    } else if (category == ActivityFeedCategory.Dealsheet) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.DealSheet_MarkedasSold,
        SpecialActionTypeIds.DealSheet_Watched,
        SpecialActionTypeIds.DealSheet_Unwatched,
        SpecialActionTypeIds.DealSheet_MarkedasNotOwned,
        SpecialActionTypeIds.DealSheet_MarkedasPaidOff,
        SpecialActionTypeIds.DealSheet_ViewedDealSheet,
        SpecialActionTypeIds.DealSheet_ViewedCarFaxReport,
        SpecialActionTypeIds.DealSheet_ViewedCarProofReport,
        SpecialActionTypeIds.DealSheetAccess_ManualReassign,
        SpecialActionTypeIds.DealSheetAccess_ManualGrantAccess,
        SpecialActionTypeIds.DealSheetAccess_ManualRevokeAccess,
        SpecialActionTypeIds.DealSheet_ViewedCarProof,
        SpecialActionTypeIds.DealSheetAccess_AutomaticReassign,
        SpecialActionTypeIds.DealSheetAccess_AutomaticGrantAccess
      ];
    } else if (category == ActivityFeedCategory.DeskIt) {
      SpecialActionTypeCategory = [SpecialActionTypeIds.Desking_PushedDeal];
    } else if (category == ActivityFeedCategory.Desking) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Desking_DeskStarted,
        SpecialActionTypeIds.Desking_DealStarted,
        SpecialActionTypeIds.Desking_CoBuyerAdded
      ];
    } else if (category == ActivityFeedCategory.GarageUpdate) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.GarageUpdate_TradeValue,
        SpecialActionTypeIds.GarageUpdate_Payoff,
        SpecialActionTypeIds.GarageUpdate_Mileage,
        SpecialActionTypeIds.GarageUpdate_Price,
        SpecialActionTypeIds.GarageUpdate_NoLongerOwns,
        SpecialActionTypeIds.GarageUpdate_Reopen,
        SpecialActionTypeIds.GarageUpdate_FinancialWizard,
        SpecialActionTypeIds.GarageUpdate_VehiclePurchasedByDealer,
        SpecialActionTypeIds.GarageUpdate_MarkedAsSold
      ];
    } else if (category == ActivityFeedCategory.GenericActivity) {
      // TODO: This does not display on UI. Investigate
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.GenericActivity_OpportunitySearch,
        SpecialActionTypeIds.GenericActivity_CustomerSearch,
        SpecialActionTypeIds.GenericActivity_GenericActivity
      ];
    } else if (category == ActivityFeedCategory.IM) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.IntelligentMarketing_IMpUrlViewed,
        SpecialActionTypeIds.IntelligentMarketing_IMpURLLead
      ];
    } else if (category == ActivityFeedCategory.Lead) {
      // TODO: This does not display on UI. Investigate
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.LeadManagement_LeadCreated,
        SpecialActionTypeIds.LeadManagement_Active,
        SpecialActionTypeIds.LeadManagement_Bad,
        SpecialActionTypeIds.LeadManagement_Duplicate,
        SpecialActionTypeIds.LeadManagement_Lost,
        SpecialActionTypeIds.LeadManagement_SoldPending,
        SpecialActionTypeIds.LeadManagement_SoldDelivered,
        SpecialActionTypeIds.LeadManagement_ReactivateLostLead,
        SpecialActionTypeIds.LeadManagement_Completed,
        SpecialActionTypeIds.LeadManagement_LeadAutoClose,
        SpecialActionTypeIds.LeadsExported_LeadsExported,

        SpecialActionTypeIds.LeadManagement_LeadTypeUpdateInternet,
        SpecialActionTypeIds.LeadManagement_LeadTypeUpdateShowroom,
        SpecialActionTypeIds.LeadManagement_LeadTypeUpdatePhone,
        SpecialActionTypeIds.LeadManagement_LeadSourceUpdate
      ];
    } else if (category == ActivityFeedCategory.Notes) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.PostedNote_UpgradeProposal,
        SpecialActionTypeIds.PostedNote_Miscellaneous,
        SpecialActionTypeIds.PostedNote_NotInterested,
        SpecialActionTypeIds.PostedNote_NoLongerOwns,
        SpecialActionTypeIds.PostedNote_AppointmentSet,
        SpecialActionTypeIds.PostedNote_OnetoOneOfferPrinted,
        SpecialActionTypeIds.PostedNote_Sold,
        SpecialActionTypeIds.PostedNote_SpoketoClient,
        SpecialActionTypeIds.PostedNote_TestDriveDone,
        SpecialActionTypeIds.PostedNote_SpokeToClient,
        SpecialActionTypeIds.LogANote_LogNote,
        SpecialActionTypeIds.Showroom_Visit_Note
      ];
    } else if (category == ActivityFeedCategory.CRM) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.ManualPushtoCRM_Unknown,
        SpecialActionTypeIds.ManualPushtoCRM_PushedtoCRM
      ];
    } else if (category == ActivityFeedCategory.Opportunity) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.OpportunitySearch_OpportunitySearch,
        SpecialActionTypeIds.SavedSearch_OpportunitySearch,
        SpecialActionTypeIds.OpportunityExport_Print,
        SpecialActionTypeIds.OpportunityExport_Export
      ];
    } else if (category == ActivityFeedCategory.Pando) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.PandoProcess_Started,
        SpecialActionTypeIds.PandoProcess_Claimed,
        SpecialActionTypeIds.PandoProcess_AutoClaimed,
        SpecialActionTypeIds.PandoProcess_Assigned,
        SpecialActionTypeIds.PandoProcess_Reassigned,
        SpecialActionTypeIds.PandoProcess_Declined,
        SpecialActionTypeIds.PandoProcess_Canceled,
        SpecialActionTypeIds.PandoProcess_AutoCanceled,
        SpecialActionTypeIds.PandoProcess_Completed
      ];
    } else if (category == ActivityFeedCategory.Print) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.PrintedOffer_PrintedOffer
      ];
    } else if (category == ActivityFeedCategory.Reassignment) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Reassignment_TaskReassignment,
        SpecialActionTypeIds.Reassignment_ContactReassignment,
        SpecialActionTypeIds.Reassignment_LeadReassignment,
        SpecialActionTypeIds.Reassignment_LeadAssignment
      ];
    } else if (category == ActivityFeedCategory.RecommendedAction) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.RecommendedAction_Call,
        SpecialActionTypeIds.RecommendedAction_Email
      ];
    } else if (category == ActivityFeedCategory.Sale) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Sale_PendingSale,
        SpecialActionTypeIds.Sale_NewSale,
        SpecialActionTypeIds.Sale_ValidatedSale,
        SpecialActionTypeIds.Sale_Retail,
        SpecialActionTypeIds.Sale_Lease,
        SpecialActionTypeIds.Sale_Cash,
        SpecialActionTypeIds.Sale_Balloon,
        SpecialActionTypeIds.Sale_RetailSeed,
        SpecialActionTypeIds.Sale_LeaseSeed
      ];
    }
    // else if (category == ActivityFeedCategory.Saved) {
    //   SpecialActionTypeCategory = [
    //     SpecialActionTypeIds.OpportunitySearchSavedSearch,
    //   ];
    // }
    else if (category == ActivityFeedCategory.Showroom) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitstarted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitrestarted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitcompleted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitdemostarted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitdemocompleted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisittradeappraisalstarted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisittradeappraisalcompleted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitwriteupstarted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitwriteupcompleted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitmanagerturnoverstarted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitmanagerturnovercompleted,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitcompletedSold,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitautoclose,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitDemoCanceled,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitTradeAppraisalCanceled,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitWriteupCanceled,
        SpecialActionTypeIds.ShowroomVisit_ShowroomVisitManagerTurnoverCanceled
      ];
    } else if (category == ActivityFeedCategory.Delivery) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Delivery_Deliverystarted,
        SpecialActionTypeIds.Delivery_Deliveryrestarted,
        SpecialActionTypeIds.Delivery_Deliverycompleted,
        SpecialActionTypeIds.Delivery_Deliveryfinanceandinsurancestarted,
        SpecialActionTypeIds.Delivery_Deliveryfinanceandinsurancecompleted,
        SpecialActionTypeIds.Delivery_Deliveryaccessoriesintrostarted,
        SpecialActionTypeIds.Delivery_Deliveryaccessoriesintrocompleted,
        SpecialActionTypeIds.Delivery_Deliveryserviceintrostarted,
        SpecialActionTypeIds.Delivery_Deliveryserviceintrocompleted,
        SpecialActionTypeIds.Delivery_Deliverytechintrostarted,
        SpecialActionTypeIds.Delivery_Deliverytechintrocompleted,
        SpecialActionTypeIds.Delivery_DeliveryFinanceAndInsuranceCanceled,
        SpecialActionTypeIds.Delivery_DeliveryAccessoriesIntroCanceled,
        SpecialActionTypeIds.Delivery_DeliveryServiceIntroCanceled,
        SpecialActionTypeIds.Delivery_DeliveryTechIntroCanceled
      ];
    } else if (category == ActivityFeedCategory.ViewProfile) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.ViewProfile_ViewSnapshot,
        SpecialActionTypeIds.ViewProfile_ViewVehicle,
        SpecialActionTypeIds.ViewProfile_ViewProfile,
        SpecialActionTypeIds.ViewProfile_ViewService,
        SpecialActionTypeIds.ViewProfile_ViewActiveSalesLeads,
        SpecialActionTypeIds.ViewProfile_ViewActiveServiceLeads,
        SpecialActionTypeIds.ViewProfile_ViewLeadHistory,
        SpecialActionTypeIds.ViewProfile_ViewMessages,
        SpecialActionTypeIds.ViewProfile_ViewEngagement,
        SpecialActionTypeIds.ViewProfile_ViewResolution,
        SpecialActionTypeIds.ViewProfile_ViewChangelog,
        SpecialActionTypeIds.ViewProfile_ViewActivity,
        SpecialActionTypeIds.ViewProfile_ViewGarage
      ];
    } else if (category == ActivityFeedCategory.Survey) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.Survey_Response_Received,
        SpecialActionTypeIds.Negative_Survey_Rating_Received,
        SpecialActionTypeIds.Positive_Survey_Rating_Received,
        SpecialActionTypeIds.Neutral_Survey_Rating_Received,
        SpecialActionTypeIds.Survey_Sent,
        SpecialActionTypeIds.Survey_Failed_To_Send
      ];
    } else if (category == ActivityFeedCategory.VinScan) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.VinScan_VINScancompleted
      ];
    } else if (category == ActivityFeedCategory.DMSPush) {
      SpecialActionTypeCategory = [SpecialActionTypeIds.DMSPush_SentToDMS];
    } else if (category == ActivityFeedCategory.FinancePush) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.PreScreen_Completed,
        SpecialActionTypeIds.CreditReport_Completed,
        SpecialActionTypeIds.OFAC_Completed
      ];
    } else if (category == ActivityFeedCategory.LeadTrade) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.LeadTrade_Added,
        SpecialActionTypeIds.LeadTrade_Updated,
        SpecialActionTypeIds.LeadTrade_Deleted
      ];
    } else if (category == ActivityFeedCategory.InventoryMatch) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.InventoryMatch_Completed
      ];
    } else if (category == ActivityFeedCategory.HappyBirthday) {
      SpecialActionTypeCategory = [SpecialActionTypeIds.HappyBirthday];
    } else if (category == ActivityFeedCategory.PAL) {
      SpecialActionTypeCategory = [
        SpecialActionTypeIds.PAL_PersonalAccessClicked,
        SpecialActionTypeIds.PAL_CustomerLinkViewed,
        SpecialActionTypeIds.PAL_CustomerLink_VehicleLiked,
        SpecialActionTypeIds.PAL_PersonalAccessLink_InboundMessage,
        SpecialActionTypeIds.PAL_CustomerLink_RequestVehicleInfo,
        SpecialActionTypeIds.PAL_CustomerLink_TradeQuoteRequested,
        SpecialActionTypeIds.PAL_CustomerLink_ServiceAppointmentRequested
      ];
    }
    return SpecialActionTypeCategory;
  },
  getOrLoadPlatformSettings(platformId) {
    return new Promise(resolve => {
      resolve(store.getters.getPlatformInfo(platformId));
    });
  },
  getOrLoadDealerSettings(platformId) {
    return new Promise(resolve => {
      if (!platformId) {
        resolve(null);
        return;
      }
      const dealerSettings = store.getters.DealerSettings.find(
        setting => setting.AccountPlatformID == platformId
      );
      if (dealerSettings && dealerSettings.AccountPlatformID) {
        resolve(dealerSettings);
        return;
      } else {
        resolve(null);
      }
    });
  },
  getOrLoadAMDealerSettings(platformId) {
    return new Promise(async resolve => {
      const CXMStores = store.getters.CXMStores;
      if (CXMStores && CXMStores.length > 0 && platformId) {
        const dealerStore = CXMStores.find(
          store => store.AccountPlatformID == platformId
        );
        const dealerId =
          dealerStore && dealerStore.AutoAlertDealerID
            ? dealerStore.AutoAlertDealerID
            : null;
        if (!dealerId) {
          resolve(null);
          return;
        }
        const dealerSetting = store.getters.AMDealerSettings.find(
          setting =>
            setting && setting.dealer && setting.dealer.dealerID == dealerId
        );
        if (dealerSetting && dealerSetting.dealer) {
          resolve(dealerSetting);
          return;
        }
        await store
          .dispatch("loadAMDealerSetting", dealerId)
          .then(response => resolve(response))
          .catch(_ => resolve(null));
      } else {
        resolve(null);
      }
    });
  },
  async getOrLoadAssignmentEditSettings(platformId) {
    if (platformId) {
      let settings = store.getters.AssignmentEditSettings.find(
        setting => setting.accountPlatformId == platformId
      );

      if (settings) {
        return settings;
      }
      settings = await store.dispatch("getAssignmentEditSettings", platformId);
      return settings;
    } else {
      return null;
    }
  },
  getOrLoadDealerPackage(platformId) {
    return new Promise((resolve, reject) => {
      if (!platformId) {
        resolve(null);
        return;
      }
      let settings = store.getters.DealersPackages(platformId);
      if (!settings) {
        store
          .dispatch("getDealersPackages", platformId)
          .then(response => {
            resolve(response);
          })
          .catch(err => {
            resolve(null);
          });
      } else {
        resolve(settings);
      }
    });
  },
  getUrlParameterByName: function(name) {
    try {
      let url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    } catch (err) {
      return "";
    }
  },
  getNavMenuFilter: function(path, NavMenuCategory, NavMenuSubcategory) {
    if (path && path.indexOf("/") >= 0) {
      path = path.substr(path.lastIndexOf("/") + 1);
    }

    let category = 0,
      subcategory = null;

    if (path) {
      path = path.toLowerCase();
      // CUSTOMER SEARCH
      if (path == "contactsearch") {
        category = NavMenuCategory.ContactSearch;
      }
      // DATA MINING
      else if (path == "opportunitiessearch") {
        category = NavMenuCategory.DataMining;
        subcategory = NavMenuSubcategory.OpportunitiesSearch;
      } else if (path == "opportunitiesdashboard") {
        category = NavMenuCategory.DataMining;
        subcategory = NavMenuSubcategory.OpportunitiesDashboard;
      } else if (path == "priorityopportunities") {
        category = NavMenuCategory.DataMining;
        subcategory = NavMenuSubcategory.PriorityOpportunities;
      } else if (path == "unmatcheddmssales") {
        category = NavMenuCategory.DataMining;
        subcategory = NavMenuSubcategory.UnmatchedDMSSales;
      }
      // SERVICE
      else if (path == "serviceexperience") {
        category = NavMenuCategory.ServiceExperience;
        subcategory = NavMenuSubcategory.ServiceExperience;
      } else if (path == "slmdashboard" || path == "operatorspanel") {
        category = NavMenuCategory.ServiceExperience;
        subcategory =
          path == "slmdashboard"
            ? NavMenuSubcategory.SLMDashboard
            : NavMenuSubcategory.OperatorsPanel;
      }
      // INVENTORY
      else if (path == "inventory") {
        category = NavMenuCategory.Inventory;
        subcategory = NavMenuSubcategory.InventorySearch;
      } else if (path == "wishlist") {
        category = NavMenuCategory.Inventory;
        subcategory = NavMenuSubcategory.InventoryWishlist;
      }
      // CXM LOGS
      else if (path == "leadsdashboard") {
        category = NavMenuCategory.CXMLogs;
        subcategory = NavMenuSubcategory.LeadsDashboard;
      } else if (path == "showroomdashboard") {
        category = NavMenuCategory.CXMLogs;
        subcategory = NavMenuSubcategory.ShowroomDashboard;
      } else if (path == "deliverydashboard") {
        category = NavMenuCategory.CXMLogs;
        subcategory = NavMenuSubcategory.DeliveryDashboard;
      } else if (path == "calltrackingdashboard") {
        category = NavMenuCategory.CXMLogs;
        subcategory = NavMenuSubcategory.CallTrackingDashboard;
      }
      // DASHBOARDS
      else if (path == "managerdashboard") {
        category = NavMenuCategory.Dashboards;
        subcategory = NavMenuSubcategory.ManagerDashboard;
      } else if (path == "bdcdashboard") {
        category = NavMenuCategory.Dashboards;
        subcategory = NavMenuSubcategory.BDCDashboard;
      } else if (path == "salesdashboard") {
        category = NavMenuCategory.Dashboards;
        subcategory = NavMenuSubcategory.SalesDashboard;
      }
      // REPORTS
      else if (path == "reports") {
        category = NavMenuCategory.Reports;
      }
      // WORKFLOW MANAGER
      else if (path == "workflowmanager") {
        category = NavMenuCategory.RulesAdministration;
      }
    }

    return {
      Category: category,
      Subcategory: subcategory
    };
  },
  parseToJSONString: function(object) {
    if (object) {
      try {
        return JSON.stringify(object);
      } catch (ex) {
        return null;
      }
    }
  },
  parseStringToJSON: function(value) {
    try {
      if (!value || value.trim().length == 0) return null;
      const parsedData = JSON.parse(value);
      // If the JSON data is corrupted, return null
      return typeof parsedData == "object" ? parsedData : null;
    } catch (e) {
      return null;
    }
  },
  validatePermissionsAndOpenProfile: function(
    contactId,
    userId,
    tab,
    includePreviousState,
    optionalData
  ) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("getUserContactPermissions", {
          contactId: contactId,
          userId: userId
        })
        .then(response => {
          if (!response) {
            EventBus.$emit(EventBusEvents.EmitNoPermissionToViewContact, {
              HasAccess: false
            });
            resolve({
              HasAccess: false
            });
          } else {
            if (!includePreviousState) {
              store.dispatch("closeRightNavSection").then(() => {
                store
                  .dispatch("updateRightNavSection", {
                    Type: RightNavContentType.CustomerDashboard,
                    Subtype: tab,
                    Filter: contactId,
                    Mode: RightNavMode.PanelOverlay,
                    RemovePreviousState: true,
                    OptionalData: optionalData
                  })
                  .then(() => {
                    // store.dispatch("toggleSideNav", true);
                  });
                resolve({
                  HasAccess: true
                });
              });
            } else {
              store
                .dispatch("updateRightNavSection", {
                  Type: RightNavContentType.CustomerDashboard,
                  Subtype: tab,
                  Filter: contactId,
                  Mode: RightNavMode.PanelOverlay,
                  RemovePreviousState: false,
                  OptionalData: optionalData
                })
                .then(() => {
                  // store.dispatch("toggleSideNav", true);
                });
              resolve({
                HasAccess: true
              });
            }
          }
        })
        .catch(response => {
          // Resolving it here to avoid console log errors but also keeping track of failed API call through "ErrorCheckingPermissions" property
          resolve({
            HasAccess: false,
            ErrorCheckingPermissions: true
          });
          EventBus.$emit(EventBusEvents.EmitNoPermissionToViewContact, {
            HasAccess: false,
            ErrorCheckingPermissions: true
          });
        });
    });
  },
  sortByPropertyAsc: function(property) {
    return function(a, b) {
      let valueOfA = a[property]
        ? typeof a[property] == "number"
          ? a[property]
          : a[property].toLowerCase()
        : "";
      let valueOfB = b[property]
        ? typeof b[property] == "number"
          ? b[property]
          : b[property].toLowerCase()
        : "";
      return valueOfA === valueOfB ? 0 : valueOfA > valueOfB ? 1 : -1;
    };
  },
  sortByPropertyDesc: function(property) {
    return function(a, b) {
      let valueOfA = a[property]
        ? typeof a[property] == "number"
          ? a[property]
          : a[property].toLowerCase()
        : "";
      let valueOfB = b[property]
        ? typeof b[property] == "number"
          ? b[property]
          : b[property].toLowerCase()
        : "";

      return valueOfA === valueOfB ? 0 : valueOfA > valueOfB ? -1 : 1;
    };
  },
  updateHTMLLinksIfAny: function(messageText) {
    if (messageText && messageText.length > 0) {
      messageText = messageText.replace(
        /<a href=/g,
        "<a target='_blank' href="
      );
    }
    return messageText;
  },
  getFilterInputType: function(filterId, FilterTypes) {
    if (FilterTypes && FilterTypes.length > 0) {
      let selectedParentFilterType = FilterTypes.find(
        x => x.filters.findIndex(y => y.id == filterId) > -1
      );
      if (
        selectedParentFilterType.filters &&
        selectedParentFilterType.filters.length > 0
      ) {
        let c_filter = selectedParentFilterType.filters.find(
          x => x.id == filterId
        );
        if (!c_filter) return;

        if (
          c_filter.id == ChildFilter.TimeSinceRODate ||
          c_filter.id == ChildFilter.TimeSinceDealEnd ||
          c_filter.id == ChildFilter.TimeSinceRODateMoreThan
        )
          return "filterswithduration";
        else if (
          c_filter.id == ChildFilter.AlertType ||
          c_filter.id == ChildFilter.AlertAndType
        ) {
          return "alert";
        } else if (c_filter.dataType == "int") return "int";
        else if (c_filter.dataType == "float") {
          return "float";
        } else if (
          c_filter.name &&
          c_filter.name.toLowerCase().indexOf("date") > -1
        )
          return "datetime";
        else if (
          (c_filter.dataType == "json" && c_filter.id != ChildFilter.Stock) ||
          c_filter.id == ChildFilter.ServiceAdvisorName ||
          c_filter.id == ChildFilter.CurrentBankName
        )
          return "dropdown";
        else if (c_filter.dataType == "bool") return "bool";
        else return "text";
      }
    }
  },
  generateIconUrl(icon, color) {
    return `https://assets.autoalert.com/img/autoalert-icons/icon-${icon}-${color}.svg`;
  },
  getActivityTypeImageUrl: function(categoryId, color) {
    const matchingCategory = RecentActivityTypes.find(
      ra => ra.id == categoryId
    );
    if (matchingCategory)
      return this.generateIconUrl(matchingCategory.icon, color);
    return null;
  },
  getAlertIcon: function(alertType) {
    let filePath =
      "https://assets.autoalert.com/img/autoalert-icons/icon-alert-";
    switch (alertType) {
      case "A":
        return filePath + "alert.svg";
      case "C":
        return filePath + "contract-end.svg";
      case "S":
        return filePath + "service.svg";
      case "M":
        return filePath + "mileage.svg";
      case "W":
        return filePath + "warranty.svg";
      case "F":
        return filePath + "flex.svg";
      case "I":
        return filePath + "in-market.svg";
      case "E":
        return filePath + "engaged.svg";
      case "P":
        return filePath + "pending-service.svg";
      default:
        return "";
    }
  },
  getCurrentCustomerScope: function() {
    if (store && store.getters && store.getters.CurrentContact) {
      return store.getters.CurrentContact &&
        store.getters.CurrentContact.accountPlatformId
        ? [store.getters.CurrentContact.accountPlatformId]
        : [];
    }
    return [];
  },
  getUserStatus(status) {
    switch (status) {
      case CoreUserStatus.Active:
        return "";
      case CoreUserStatus.Inactive:
        return " (Inactive)";
      case CoreUserStatus.Pending:
        return " (Pending)";
      default:
        return "";
    }
  },
  getActiveUsersFirst: function(users) {
    if ((users || []).length == 0) return [];

    let activeUsers = users.filter(
      usr => usr.UserStatus === CoreUserStatus.Active
    );
    let nonActiveUsers = users.filter(
      usr => usr.UserStatus !== CoreUserStatus.Active
    );
    let sortedActiveUsers = activeUsers.sort(
      (a, b) => (a.Name || "").toLowerCase() - (b.Name || "").toLowerCase()
    );
    let sortedNonActiveUsers = nonActiveUsers.sort(
      (a, b) => (a.Name || "").toLowerCase() - (b.Name || "").toLowerCase()
    );
    return sortedActiveUsers.concat(sortedNonActiveUsers);
  },
  checkIfvAutoIsEnabledForStore: function(platformId) {
    if (!platformId) return null;
    return new Promise(resolve => {
      let settings = store.getters.VAutoSettings;
      let storeSettings = settings
        ? settings.find(x => x.accountPlatformId == platformId)
        : null;
      if (!storeSettings) {
        store
          .dispatch("checkIfStoreHasvAutoEnabled", {
            accountPlatformId: platformId
          })
          .then(response => {
            resolve(response);
          })
          .catch(() => {
            resolve(null);
          });
      } else {
        resolve(storeSettings);
      }
    });
  },
  checkIfVinCueIsEnabledForStore: function(platformId) {
    if (!platformId) return null;
    return new Promise(resolve => {
      let settings = store.getters.VinCue;
      let storeSettings = settings
        ? settings.find(x => x.accountPlatformId == platformId)
        : null;
      if (!storeSettings) {
        store
          .dispatch("checkIfStoreHasVinCueEnabled", {
            accountPlatformId: platformId
          })
          .then(response => {
            resolve(response);
          })
          .catch(() => {
            resolve(null);
          });
      } else {
        resolve(storeSettings);
      }
    });
  },
  loadGarageTabIntegrationsForStore: function(platformId) {
    if (!platformId) return null;
    return new Promise(resolve => {
      let integrations = store.getters.AllDealerIntegrations;
      let dealerIntegration = integrations
        ? integrations.find(x => x.accountPlatformId == platformId)
        : null;
      if (!dealerIntegration) {
        store
          .dispatch("getGarageTabIntegrationsByPlatformId", platformId)
          .then(response => {
            resolve(response);
          })
          .catch(() => {
            resolve(null);
          });
      } else {
        resolve(dealerIntegration);
      }
    });
  },
  getOrLoadCanPushToDMS: function(platformId) {
    if (!platformId) return null;
    return new Promise(resolve => {
      let loadedDmsPushSettings = store.getters.CanPushToDMS;
      let canPush = loadedDmsPushSettings.find(lfps => {
        return lfps.accountPlatformId == platformId;
      });
      if (!canPush) {
        store
          .dispatch("canPushToDMS", { accountPlatformId: platformId })
          .then(response => {
            resolve(response);
          })
          .catch(() => {
            resolve(null);
          });
      } else {
        resolve();
      }
    });
  },
  getOrLoadCanPushToFinance: function(platformId) {
    if (!platformId) return null;
    return new Promise(resolve => {
      let loadedFinancePushSettings = store.getters.CanPushToFinance;
      let canPush = loadedFinancePushSettings.find(lfps => {
        return lfps.accountPlatformId == platformId;
      });
      if (!canPush) {
        store
          .dispatch("canPushToFinance", {
            accountPlatformId: platformId
          })
          .then(response => {
            resolve(response);
          })
          .catch(() => {
            resolve(null);
          });
      } else {
        return resolve(canPush);
      }
    });
  },
  submitFordOasisRequest: function(request) {
    let vm = this;
    if (!request) {
      EventBus.$emit(EventBusEvents.HelperFunctionSnotifyNotification, {
        message:
          "There was an error processing your request. Please try again later.",
        success: false
      });
      return;
    }
    store
      .dispatch("submitFordOasisRequest", request)
      .then(response => {
        if (response && response.oasisUrl) {
          window.open(response.oasisUrl, "_blank");
        }
      })
      .catch(ex => {
        EventBus.$emit(EventBusEvents.HelperFunctionSnotifyNotification, {
          message:
            "There was an error processing your request. Please try again later.",
          success: false
        });
      });
  },
  getCountryCodeForStore: function(platformId) {
    if (!platformId) return null;
    return new Promise(resolve => {
      let allPlatformDetails = store.getters.AllDealersCountryCodes;
      let hasPlatform = allPlatformDetails
        ? allPlatformDetails.some(x => x.accountPlatformId == platformId)
        : false;

      if (!hasPlatform) {
        store
          .dispatch("getPlatformDetails", platformId)
          .then(response => {
            resolve(response);
          })
          .catch(() => {
            resolve(null);
          });
      } else {
        resolve(hasPlatform);
      }
    });
  },
  getFinancialTransactionTypes: function() {
    return [
      {
        name: this.getSaleTypeName("C"),
        id: SaleTypes.Cash
      },
      {
        name: this.getSaleTypeName("L"),
        id: SaleTypes.Lease
      },
      {
        name: this.getSaleTypeName("P"),
        id: SaleTypes.Retail
      },
      {
        name: this.getSaleTypeName("B"),
        id: SaleTypes.Balloon
      }
    ];
  },
  getSaleTypeName(symbol) {
    let saleTypeName = SaleTypeNames.find(
      saleType => saleType.symbol == symbol
    );
    return saleTypeName.name;
  },
  escapeHtml: function(text) {
    //Escape html tags
    try {
      //If there is any user entered markup html in the message, escape it
      if (text && text.trim()) {
        return text
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      }
    } catch (err) {}
    return text;
  },
  linkify: function(text) {
    if (!text) {
      return null;
    }
    return linkifyHtml(text, {
      target: {
        url: "_blank"
      }
    });
  },
  convertMiToKM: function(text) {
    let tmpStr = text.toString().split(" ");

    let newVal = tmpStr.map(e => {
      if (e === "mi") {
        e = "km";
      } else if (e === "Mi" || e.toLowerCase() === "mi") {
        e = "Km";
      } else if (e === "mile") {
        e = "kilometer";
      } else if (e === "Mile" || e.toLowerCase() === "mile") {
        e = "Kilometer";
      } else if (e === "miles") {
        e = "kilometers";
      } else if (e === "Miles" || e.toLowerCase() === "miles") {
        e = "Kilometers";
      }
      return e;
    });

    return newVal.join(" ");
  },
  getDMSUsersFirst(userlist) {
    if (!userlist || userlist.length == 0) return [];
    let salespeople = JSON.parse(JSON.stringify(userlist));
    salespeople.sort((a, b) => {
      if (!a.DMSUserId && !b.DMSUserId) {
        return a.Name > b.Name ? 1 : -1;
      }
      if (!a.DMSUserId || a.DMSUserId.trim() == "") {
        return 1;
      }
      if (!b.DMSUserId || b.DMSUserId.trim() == "") {
        return -1;
      }
      return a.Name > b.Name ? 1 : -1;
    });
    return salespeople;
  },
  validateEmail: function (email) {
    return (email || "").match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  },
  validatePhoneNumber: function (phone) {
    return /^(?:\+1)?\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(phone);
  },
  validateAlphanumeric: function (word) {
    return /[a-zA-Z]+/.test(word) && /[0-9]+/.test(word);
  },
  downloadFile(content, fileNameWithExtension, type) {
    const blob = new Blob([content], { type: type });
    const url = URL.createObjectURL(blob);

    // Create temporary elements and trigger download
    const anchorTag = document.createElement("a");
    anchorTag.setAttribute("href", url);
    anchorTag.setAttribute("download", fileNameWithExtension);
    document.body.appendChild(anchorTag);
    anchorTag.click();

    // Remove temporary elements
    document.body.removeChild(anchorTag);
    URL.revokeObjectURL(url);
  }
};

export var csv = {
  processCSV(response) {
    const contentDisposition = response.headers
      ? response.headers["content-disposition"]
      : undefined;
    const fileNameMatch = contentDisposition
      ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
      : undefined;
    const fileName =
      fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
    return { fileName: fileName, data: response.data };
  }
};



// WEBPACK FOOTER //
// ./src/lib/utilities/HelperFunctions.js